import React from 'react';
import PropTypes from 'prop-types';
import { Utils, translate } from 'versafleet-core';

class HeaderProfileEditButton extends React.Component {
  _onClick = () => {
    if (!Utils.Helper.isNullOrUndefined(this.props.onClick())) {
      this.props.onClick();
    }
    Utils.Router.transitionTo('/profile');
  }

  render() {
    return (
      <div className="vf-header-profile__edit-button" onClick={this._onClick}>
        <div className="vf-header-profile__edit-button__icon">
          <i className="versa-edit" />
        </div>
        <div className="vf-header-profile__edit-button__text">
          {this.props.strings.buttons.updateProfile}
        </div>
      </div>
    );
  }
}

HeaderProfileEditButton.displayName = 'Header Profile Edit Button';

HeaderProfileEditButton.propTypes = {
  onClick: PropTypes.func,
  strings: PropTypes.shape().isRequired,
};

HeaderProfileEditButton.defaultProps = {
  onClick: null,
};

export default translate('HeaderProfile')(HeaderProfileEditButton);
